import React from "react";
import PropTypes from "prop-types";
import { selectOptionType } from "custom-prop-types";
import styles from "components/common/radio-tab.scss";

export const RadioTab = ({ onChange, options, selectedOptionKey }) => (
  <div className={ styles.container }>
    { options.map(renderOption(onChange, selectedOptionKey)) }
  </div>
);

RadioTab.propTypes = {
  onChange: PropTypes.func.isRequired, // (selectOptionType) => void
  options: PropTypes.arrayOf(selectOptionType).isRequired,
  selectedOptionKey: PropTypes.string
};

RadioTab.defaultProps = {
  selectedOptionKey: null
};

const renderOption = (onChange, selectedOptionKey) => (option) => (
  <Option
    data={ option }
    key={ option.key }
    onClick={ onChange }
    selected={ option.key === selectedOptionKey }
  />
);

const Option = ({ data, onClick, selected }) => (
  <div
    className={ selected ? `${styles.option} ${styles["option--selected"]}` : styles.option }
    onClick={ () => onClick(data) }
  >
    { data.name }
  </div>
);

Option.propTypes = {
  data: selectOptionType.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/common/radio-tab.jsx